import React, { useState } from "react";
import { Helmet } from "react-helmet";
import "./HeaderPage.css";
import CustomModal from "./CustomModal";

const HeaderPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Helmet>
        <title>Digital Marketing Course with International Placement | Arrow Digital Marketing</title>
        <meta
          name="description"
          content="Master digital marketing with zero experience. Get guaranteed international placement, hands-on training in Google Ads, Facebook Ads, SEO & more. Join Arrow Digital Marketing now!"
        />
        <meta
          name="keywords"
          content="Digital Marketing Course, Arrow Digital Marketing, International Placement, Facebook Ads, Google Ads, Portfolio Website, SEO, Online Earning, Job Guarantee"
        />
        <meta name="author" content="Arrow Digital Marketing by Anup Batra" />
        <meta property="og:title" content="Discover The Power Of Digital Marketing | Arrow Digital Marketing" />
        <meta property="og:description" content="Guaranteed International Placement. Practical training in digital marketing with tools, templates, and real-world experience." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.arrowdigitalmarketing.com" />
        <meta property="og:image" content="https://www.arrowdigitalmarketing.com/assets/seo-preview.jpg" />
        <link rel="canonical" href="https://www.arrowdigitalmarketing.com" />
      </Helmet>

      <div className="course-ad-container">
        <div className="header-text">
          <p className="subheading">
            Guaranteed International Placement
          </p>
          <h1>
            Discover The Power Of{" "}
            <span className="highlight-primary">Digital Marketing</span> —
            Master Practical Skills That Help You{" "}
            <span className="highlight-secondary">Earn a High Salary!</span>
          </h1>
        </div>

        <div className="video-section">
          <div className="video-container">
            <video
              className="video-preview"
              src="/videoads.mp4"
              title="Promotional Video"
              controls
              muted
              autoPlay
              loop
            />
          </div>
        </div>

        <div className="pricing-section">
          <h2>
            A Step-by-Step Course Built For Students With Zero Experience —
            Practical, Easy, And Designed To Make You Job-Ready!
          </h2>
          <button className="pricing-button" onClick={openModal}>
            Download Our Brochure
          </button>
        </div>

        <div className="features-section">
          <ul>
            <li>✅ Learn From Scratch — No Prior Knowledge Needed</li>
            <li>
              ✅{" "}
              <span className="white-text">
                Master Facebook, Instagram & Google Ads, LinkedIn Ads With Hands-On Examples
              </span>
            </li>
            <li>✅ Get Access To Real Campaign Tools And Templates Used By Experts</li>
            <li>
              ✅{" "}
              <span className="white-text">
                Build Your Own Portfolio Website Without Coding
              </span>
            </li>
            <li>✅ Understand SEO, Funnels, Email Marketing & More In Simple Words</li>
            <li>✅ Learn Freelancing & Internship Skills To Start Earning Online</li>
          </ul>
        </div>
      </div>

      <CustomModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default HeaderPage;
